import { Box, Typography, ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowButton, ThickChevron } from './ui/Controls';

export default function HomeSlide({
    item,
    nextItem,
    index,
    total,
    goTo,
    hoveredIndex,
    setHoveredIndex,
    appBarHeight,
}) {


    const navigate = useNavigate();

    const isFirst = index === 0;
    const isLast = index === total - 1;

    return (
        <Box
            sx={{
                height: `calc(100dvh - ${appBarHeight}px)`,
                scrollSnapAlign: 'start',
                scrollSnapStop: 'always',
                position: 'relative',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },

                alignItems: 'center',
                justifyContent: { md: 'center' },

                textAlign: { xs: 'left', md: 'left' },
                gap: { xs: 3, md: 8 },

                overscrollBehaviorY: 'contain',
                WebkitOverflowScrolling: 'touch',

                px: { xs: 3, md: 6 },
            }}

        >
            {/* Flecha arriba */}
            {!isFirst && (
                <ArrowButton
                    label="Subir"
                    onClick={() => goTo(index - 1)}
                    sx={{
                        position: 'absolute',
                        right: { xs: 16, md: 28 },
                        top: { xs: 12, md: 16 },
                        zIndex: 5,
                        '@media (hover: none)': {
                            '&:active': {
                                backgroundColor: 'rgba(25,118,210,.12)',
                                transform: 'scale(0.96)',
                            },
                        },

                    }}
                >
                    <ThickChevron direction="up" />
                </ArrowButton>
            )}

            {/* Contenido */}
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pb: { xs: 10, md: 12 },
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 1000,
                        transition: 'transform .35s ease',
                        '@media (hover: hover)': {
                            '&:hover': {
                                transform: 'translateY(-6px)',
                            },
                        },

                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 4, md: 8 },
                        }}
                    >
                        <Box
                            component="img"
                            src={
                                hoveredIndex === index
                                    ? item.iconOn || item.icon
                                    : item.icon
                            }
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            onClick={() => navigate(item.route)}
                            alt={item.title}
                            sx={{
                                width: { xs: 96, md: 200 },
                                height: { xs: 96, md: 200 },
                                objectFit: 'contain',
                                filter:
                                    hoveredIndex === index
                                        ? 'drop-shadow(0 14px 28px rgba(0,0,0,.18))'
                                        : 'drop-shadow(0 8px 16px rgba(0,0,0,.1))',
                                transition: 'all .35s ease',
                                flexShrink: 0,
                                cursor: 'pointer',
                            }}
                        />


                        {/* Textos */}
                        <Box sx={{
                            flex: 1,
                            minWidth: 0,
                        }}>
                            {/* Eyebrow */}
                            <Typography
                                sx={{
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.14em',
                                    fontSize: 12,
                                    color: 'primary.main',
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                {item.eyebrow}
                            </Typography>

                            {/* Título */}
                            <ButtonBase
                                onClick={() => navigate(item.route)}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                sx={{
                                    textAlign: 'left',
                                    borderRadius: 1,
                                    p: 0,
                                    width: "100%",
                                    display: "block",
                                    '&:hover h2': {
                                        textDecoration: 'underline',
                                        textDecorationColor: 'primary.main',
                                    },
                                }}
                            >
                                <Typography
                                    component="h2"
                                    sx={{
                                        fontSize: 'clamp(28px, 5vw, 64px)',
                                        lineHeight: { xs: 1.15, md: 1.05 },
                                        fontWeight: 700,
                                        color: 'grey.800',
                                        letterSpacing: '-0.02em',
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </ButtonBase>

                            {/* Descripción */}
                            <Typography
                                sx={{
                                    mt: { xs: 2, md: 3 },
                                    fontSize: { xs: 14, sm: 15, md: 18 },
                                    lineHeight: 1.7,
                                    color: 'grey.600',
                                    maxWidth: 760,
                                    textAlign: "justify",
                                }}
                            >

                                {item.info}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Flecha abajo */}
            {!isLast && (
                <ArrowButton
                    label="Bajar"
                    onClick={() => goTo(index + 1)}
                    sx={{
                        position: 'absolute',
                        right: { xs: 16, md: 28 },
                        bottom: { xs: 16, md: 20 },
                        zIndex: 5,
                        '@media (hover: none)': {
                            '&:active': {
                                backgroundColor: 'rgba(25,118,210,.12)',
                                transform: 'scale(0.96)',
                            },
                        },
                    }}
                >
                    <ThickChevron direction="down" />
                </ArrowButton>
            )}

            {/* Peek del siguiente (solo sm+) */}
            {!isLast && nextItem && (
                <Box
                    aria-hidden="true"
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        justifyContent: 'center',
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: { sm: 120, md: 180 },
                        pointerEvents: 'none',
                        overflow: 'hidden',
                        px: { xs: 6, md: 12 }, // 1. Mismo padding lateral que el contenedor padre
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            maxWidth: 1000,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: { xs: 4, md: 8 }, // 2. Mismo gap exacto que el principal
                            opacity: { sm: 0.1, md: 0.15 },
                            transform: {
                                sm: 'translateY(24px)',
                                md: 'translateY(32px)',
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={nextItem.icon}
                            alt=""
                            sx={{
                                width: { sm:120, md: 150, lg:170},
                                height: { sm:120,md: 150, lg:170},
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />
                        <Typography
                            component="h2"
                            sx={{
                                // 4. Mismo tamaño de fuente que el H2 principal
                                fontSize: 'clamp(18px, 5vw, 48px)',
                                lineHeight: { xs: 1.15, md: 1.05 },
                                fontWeight: 700,
                                color: 'grey.800',
                                letterSpacing: '-0.02em',
                                flex: 1,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                // 5. Margen superior para compensar la ausencia del "Eyebrow"
                                mt: { xs: 5, md: 6 }
                            }}
                        >
                            {nextItem.title}
                        </Typography>
                    </Box>
                </Box>
            )}

        </Box>
    );
}
